import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem("cookie-consent", "necessary");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-lg z-50 cookie-banner"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-slate-600 font-body text-sm leading-relaxed">
              Wir verwenden Cookies, um die Funktionalität unserer Website zu gewährleisten und unsere Inhalte zu verbessern. 
              Weitere Informationen finden Sie in unserer{" "}
              <Link 
                to="/datenschutz" 
                className="text-sky-700 hover:text-sky-800 underline"
                data-testid="cookie-privacy-link"
              >
                Datenschutzerklärung
              </Link>.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <Button
              onClick={handleAcceptNecessary}
              variant="outline"
              className="border-2 border-slate-900 text-slate-900 hover:bg-slate-50 rounded-sm font-semibold uppercase tracking-wide px-6 py-3 h-auto text-sm"
              data-testid="cookie-necessary-button"
            >
              Nur notwendige Cookies
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="bg-slate-900 text-white hover:bg-slate-800 rounded-sm font-semibold uppercase tracking-wide px-6 py-3 h-auto text-sm"
              data-testid="cookie-accept-button"
            >
              Alle akzeptieren
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
